<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="启用-确认启用"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="750px"
        append-to-body>
        <div class="content-wrap p20">
            <p class="text-color-error text-bold mb20">以下产品已经绑定客户，且为启用状态!<br/>您需要继续启用当前客户的绑定关系，还是停用原客户绑定关系，再启用当前客户绑定关系?</p>
            <el-table
                ref="dataTable"
                :data="dataList"
                tooltip-effect="dark"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :max-height="350"
                stripe
                style="width: 100%;">
                <el-table-column
                    prop="subproject_name"
                    label="推广名称"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="subproject_id"
                    label="推广ID"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="subproject_content"
                    label="推广内容"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="plat_name"
                    label="归属媒体"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="company_name"
                    label="绑定客户"
                    align="center"
                    min-width="100">
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="confirmResult('1')" class="action-btn mr20">继续启用，不停用其他客户</el-button>
            <el-button plain type="primary" @click="confirmResult('2')" class="action-btn mr20">停用其他客户且启用当前客户</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "enableResultModal",
        props:{},
        data(){
            return {
                dialogVisible:false,
                dataList:[],
            }
        },
        methods:{
            confirmResult(val){
                this.$emit('confirm',val);
                this.dialogVisible = false;
            },
            showModal(dataList){
                this.dataList = dataList;
                this.dialogVisible = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body{
        padding-top: 5px;
    }
</style>
